var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"online"},[_c('el-divider',{attrs:{"content-position":"left"}},[_c('div',{staticClass:"hospital-into-title"},[_vm._v(" 预约流程 ")])])],1),_c('div',[_c('el-empty',{attrs:{"description":"功能完善中...,敬请期待"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }